import React, { useState, useEffect } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';
// import { NoHeaderTableUpdate } from '../../Helpers/requests';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import ExportToCsv from '../../Helpers/CsvExport';

import { convertDate } from '../../Helpers/helpers';

import { DataGrid } from '@mui/x-data-grid';
import { Box, Grid, Typography, Modal, Button } from '@mui/material';

import UsersAutocomplete from '../CommonComponents/UsersAutocomplete';
import TechAutocomplete from '../CommonComponents/TechAutocomplete';
import DatePicker from '../CommonComponents/DatePicker';

import { gridStyle } from './gridStyle';

import CircleIcon from '@mui/icons-material/Circle';

const SparesUsageReport = () => {
  const [loggedData, setLoggedData] = useState([]);
  const [loggedPage, setLoggedPage] = useState(0);
  const [loggedPageSize, setLoggedPageSize] = useState(25);
  const [loggedSort, setLoggedSort] = useState([]);
  const [loggedFilter, setLoggedFilter] = useState([]);
  const [loggedTotalRows, setLoggedTotalRows] = useState(0);

  const [data, setData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);

  //FILTERS
  // const [techSelected, setTechSelected] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [techId, setTechId] = useState(null);

  const [fullFilterBlob, setFullFilterBlob] = useState([]);
  const [rangeFilterBlob, setRangeFilterBlob] = useState([]);
  const [useType, setUseType] = useState(localStorage.getItem('type'));
  const [rowData, setRowData] = useState({});

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setForceUpdate(forceUpdate + 1);
  };

  const handleFilterChange = (data, type) => {
    setTechId(data.id);
    switch (type) {
      case 'tech_username':
        let oldData = [...fullFilterBlob];
        let tempData = oldData
          .slice()
          .filter((item) => item.field !== 'tech_username');

        data === '%'
          ? setFullFilterBlob([...tempData])
          : setFullFilterBlob([
              ...tempData,
              {
                field: 'tech_username',
                search: data,
                strict: true,
              },
            ]);
        break;
      default:
        // console.log(data);
        break;
    }
  };

  const padLeft = (intVal) => {
    return intVal < 10 ? `0${intVal}` : intVal;
  };

  const handleRangeChange = (data, type) => {
    let startTime = startDate;
    let endTime = endDate;
    let oldData = [...rangeFilterBlob];

    switch (type) {
      case 'start_time':
        startTime = data;

        let currentDate = new Date();
        let dateString = `${currentDate.getFullYear()}-${padLeft(
          currentDate.getMonth() + 1
        )}-${padLeft(currentDate.getDate())} 23:59:59`;

        let tempStartData = oldData
          .slice()
          .filter((item) => item.field !== 'start_time');

        data === '%'
          ? setRangeFilterBlob([...tempStartData])
          : setRangeFilterBlob([
              ...tempStartData,
              {
                field: 'start_time',
                start: data + ' 00:00:00',
                stop: dateString,
              },
            ]);
        setStartDate(data);
        break;
      case 'stop_time':
        endTime = data;
        let firstDate = new Date(0);

        let dateString1 = `${firstDate.getFullYear()}-${padLeft(
          firstDate.getMonth() + 1
        )}-${padLeft(firstDate.getDate())} 00:00:00`;

        let tempEndData = oldData
          .slice()
          .filter((item) => item.field !== 'stop_time');

        data === '%'
          ? setRangeFilterBlob([...tempEndData])
          : setRangeFilterBlob([
              ...tempEndData,
              {
                field: 'stop_time',
                start: dateString1,
                stop: data + ' 23:59:59',
              },
            ]);
        setEndDate(data);
        break;
      default:
        // console.log(data);
        break;
    }
  };

  const handelDate = (date, subVal) => {
    const inDate = date;
    // let outDate = inDate.substring(0, inDate.lastIndexOf('T') + 1);
    // outDate = outDate + subVal;
    console.log(`Date: ${date} \nSubval: ${subVal} \nOutDate:`);
    return date;
  };

  const handleClearDateRange = () => {
    if (rangeFilterBlob.length > 0) {
      setRangeFilterBlob([]);
      const newDate = new Date();
      setStartDate(newDate);
      setEndDate(newDate);
    }
  };

  useEffect(() => {
    const newDate = new Date();
    setStartDate(newDate);
    setEndDate(newDate);
  }, []);

  useEffect(() => {
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_reports`,
        setDataFunc: setLoggedData,
        setLoadingFunc: setLoading,
        setRows: setLoggedTotalRows,
        startDate: startDate,
        endDate: endDate,
        userId: techId,
        logout,
      },
      'spare_usage_report'
    );
  }, [techId, startDate, endDate]);

  const sparesColumns = [
    {
      field: 'ticket_number',
      headerName: 'Ticket Number',
      width: 150,
      flex: 1,
    },
    {
      field: 'store_name',
      headerName: 'Store Name',
      width: 150,
      flex: 1,
    },
    { field: 'stock_code', headerName: 'Stock Code', width: 150, flex: 1 },
    {
      field: 'stock_description',
      headerName: 'Stock Description',
      width: 150,
      flex: 1,
    },
    {
      field: 'stock_qty',
      headerName: 'Quantity',
      width: 150,
      flex: 1,
    },
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '73vh', width: '100%' }}>
      <Box>
        <Grid
          container
          // marginBottom='-10px'
          columnGap={1}
        >
          <Grid xs={12} md={2}>
            <TechAutocomplete
              nameLabel='Tech Username'
              filterData={(data) => handleFilterChange(data, 'tech_username')}
            />
          </Grid>
          <Grid xs={12} md={6} container>
            <Grid xs={12} md={3}>
              <DatePicker
                dateLabel='Start Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '00:01:01'), 'start_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={1}></Grid>
            <Grid xs={12} md={3}>
              <DatePicker
                dateLabel='End Date'
                getDate={(data) =>
                  handleRangeChange(handelDate(data, '23:59:59'), 'stop_time')
                }
              ></DatePicker>
            </Grid>
            <Grid xs={12} md={1}></Grid>
            <Grid xs={12} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant='outlined'
                size='large'
                onClick={handleClearDateRange}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <Grid xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              variant='contained'
              size='large'
              type='info'
              onClick={() => {
                new ExportToCsv('spare_usage_report').ExportRawData(loggedData);
              }}
            >
              Extract Data
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Typography
        sx={{ fontWeight: 'bold' }}
        variant='h6'
        align='center'
        xs={{
          background: '#ebedf8',
          margin: '0 auto',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          textAlign: 'center',
          align: 'center',
        }}
      >
        Spares Usage
      </Typography>
      <DataGrid
        sx={{
          ...gridStyle,
          maxHeight: '75vh',
        }}
        // rows={loggedData}
        rows={loggedData}
        // getRowId={(row) => row?.tech_id}
        // rowCount={loggedTotalRows}
        // loading={loading}
        pagination
        // sortingMode='server'
        // filterMode='server'
        onSortModelChange={(model) => {
          // setLoggedPage(0);
          setLoggedSort(model);
        }}
        // onFilterModelChange={(model) => {
        //   setLoggedPage(0);
        //   setLoggedFilter(model.quickFilterValues);
        // }}
        page={loggedPage}
        // pageSize={loggedPageSize}
        // initialState={{
        //   pagination: {
        //     paginationModel: { pageSize: 5, page: 0 },
        //   },
        // }}
        // paginationMode='client'
        onPageChange={(newPage) => {
          setLoggedPage(newPage);
        }}
        onPageSizeChange={(newPageSize) => {
          setLoggedPage(0);
          setLoggedPageSize(newPageSize);
        }}
        columns={sparesColumns}
        onRowClick={(params) => {}}
        // rowsPerPageOptions={[25, 50, 100]}
        // components={{ Toolbar: CustomCustomerToolbar }}
        autoPageSize
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        initialState={{
          aggregation: {
            model: {
              calc2: 'sum',
              year: 'sum',
            },
          },
        }}
        componentsProps={
          {
            // getRowId: loggedData.tech_id,
            // toolbar: {
            //   updateOnclick: () => {
            //     setUpdateData((i) => i + 1);
            //   },
            //   filterOnClick: () => {
            //     // handleFilterOpen();
            //   },
            //   // modalState: modalState,
            // },
          }
        }
      />
    </Box>
  );
};

export default SparesUsageReport;

const ticketType = (val) => {
  switch (val) {
    case 'day_start':
      return 'Day Clock';
    case 'repair_ticket':
      return 'Repair Ticket';
    case 'install_ticket':
      return 'Install Ticket';
    default:
      break;
  }
};
